var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTime = function SvgTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#time_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 12.355a.98.98 0 1 0 0-1.962.98.98 0 0 0 0 1.962Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.62 7.205.907-.907a.734.734 0 0 0 0-1.035l-.323-.322a.734.734 0 0 0-1.035 0l-.894.894A6.965 6.965 0 0 0 7.81 4.421V3.145H6.19V4.42a6.965 6.965 0 0 0-3.465 1.414l-.895-.894a.734.734 0 0 0-1.035 0l-.322.322a.734.734 0 0 0 0 1.035l.908.907A6.964 6.964 0 0 0 0 11.375c0 3.859 3.14 7 7 7s7-3.141 7-7c0-1.562-.514-3.005-1.38-4.17ZM7 16.742a5.374 5.374 0 0 1-5.368-5.368A5.374 5.374 0 0 1 7 6.007a5.374 5.374 0 0 1 5.368 5.367A5.374 5.374 0 0 1 7 16.742ZM8.44.626H5.56a.437.437 0 0 0-.437.438v1.002c0 .241.196.437.438.437h2.878a.437.437 0 0 0 .437-.437V1.064A.437.437 0 0 0 8.44.626Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.593 11.781.814-.814 2.863 3.27a.288.288 0 0 1-.407.407l-3.27-2.863Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "time_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 .626)",
    d: "M0 0h14v17.747H0z"
  })))));
};
export default SvgTime;